"use strict";
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            ServerForm_DiagnosticsMessage: "Unexpected server error: '{0}' - {1}",
            ServerForm_GenericError: "An error has occurred. Please contact your system administrator.",
            ServerForm_InternalError: "An internal error has occurred. Please contact your system administrator.",
            ServerForm_LostConnection: "Sorry, we lost the connection temporarily. Please be patient while we reconnect you.",
            ServerForm_MissingTargetId: "Missing target id for interaction: {0}.",
            ServerForm_ProcessError: "Ignoring process {0} interactions. Process was called while we were processing interactions.",
            ServerForm_QueueError: "Ignoring queue interaction of type: {0}. The interaction was queued while we were processing interactions.",
            ServerForm_ServerTimeout: "The server took too long to respond. Please contact your system administrator.",
            // This is a development targeted error message.  TODO Task #1511150: Introduce debug setting to differentiate development/production error messages
            ServerForm_SessionEndError: "We've lost your connection. Click Close to continue working.",
            ServerForm_SystemMaintenance: "This system will be temporarily unavailable starting at {0} due to scheduled maintenance. Please save your changes and logout before the maintenance begins.",
            ServerForm_UnknownError: "Unknown error occurred. Please contact the System Administrator.",
            ServerForm_UnknownUserError: "You are not authorized to login with your current credentials. You will be redirected to the login page in a few seconds.",
            Shell_OpenEvaPane: "Wake Cortana",
            WindowManager_CannotReloadPopout: "A popout window cannot be reloaded. Please close the popout window.",
        },
    });
    function ajax(options) {
        return $.ajax(options);
    }
    $dyn.ajax = ajax;
    function postMessage(win, args) {
        var origin = $dyn.util.getOrigin($dyn.util.location.location);
        try {
            win.postMessage(args.data, origin);
        }
        catch (error) {
            $dyn.logError("Failed to postMessage to window with data: ", args.data);
            $dyn.logError(error.message);
            return false;
        }
        return true;
    }
    $dyn.postMessage = postMessage;
    var shell;
    (function (shell) {
        /** @internal serverform only */
        shell.IsUnloading = false;
        // set the default form for AX
        shell.defaultForm = {
            elementCreated: function (options) {
                if ($dyn.serverForm) {
                    $dyn.serverForm.getForm(options);
                }
            },
            menuItem: "Action:SysLoadStartPage",
        };
    })(shell = $dyn.shell || ($dyn.shell = {}));
    window.addEventListener("beforeunload", function () {
        $dyn.shell.IsUnloading = true;
    });
    // Override the default implementation of waitForClientBusy
    $dyn.util.waitForClientBusy = function () {
        if ($dyn.serverForm) {
            return $dyn.serverForm.interactionManager.hasPendingResponse(true);
        }
        else {
            // if server form is not defined (client form only)
            // there is no need to wait for responses
            return false;
        }
    };
    var serverForm;
    (function (serverForm) {
        /**
         * Enumeration that is used for minutes/seconds
         * @internal
         */
        var TimeValues;
        (function (TimeValues) {
            TimeValues[TimeValues["FiveSeconds"] = 5] = "FiveSeconds";
            TimeValues[TimeValues["ThirtySeconds"] = 30] = "ThirtySeconds";
            TimeValues[TimeValues["TwoMinutes"] = 120] = "TwoMinutes";
            TimeValues[TimeValues["FiveMinutes"] = 300] = "FiveMinutes";
            TimeValues[TimeValues["TenMinutes"] = 600] = "TenMinutes";
            TimeValues[TimeValues["ThirtyMinutes"] = 1800] = "ThirtyMinutes";
        })(TimeValues = serverForm.TimeValues || (serverForm.TimeValues = {}));
        var InteractionType;
        (function (InteractionType) {
            // TODO: There is no client difference between create and update view model - can the concepts be merged?
            InteractionType["createViewModel"] = "CreateViewModelInteraction";
            InteractionType["updateViewModel"] = "UpdateViewModelInteraction";
            InteractionType["deleteViewModel"] = "DeleteViewModelInteraction";
            InteractionType["changeViewModelId"] = "ChangeViewModelIdInteraction";
            InteractionType["createModel"] = "CreateModelInteraction";
            InteractionType["updateModel"] = "UpdateModelInteraction";
            InteractionType["updateModelCollection"] = "UpdateModelCollectionInteraction";
            InteractionType["getForm"] = "GetFormInteraction";
            InteractionType["command"] = "CommandInteraction";
            InteractionType["propertyChange"] = "PropertyChangeInteraction";
            InteractionType["commandCallback"] = "CommandCallbackInteraction";
            InteractionType["eventData"] = "EventDataInteraction";
            InteractionType["getNavigationPane"] = "GetNavigationPaneInteraction";
            InteractionType["getTileKpiValuesInteraction"] = "GetTileKpiValuesInteraction";
            InteractionType["getNavigationTileClick"] = "GetNavigationTileClickInteraction";
            InteractionType["getMenuStructureInteraction"] = "GetMenuStructureInteraction";
            InteractionType["setLookupValue"] = "SetLookupValueInteraction";
            InteractionType["navigate"] = "NavigationInteraction";
            InteractionType["taskRecorderInteraction"] = "TaskRecorderInteraction";
            InteractionType["clientRestrictedInternetInteraction"] = "ClientRestrictedInternetInteraction";
            InteractionType["restoreServerSession"] = "RestoreServerSessionInteraction";
        })(InteractionType = serverForm.InteractionType || (serverForm.InteractionType = {}));
        var CommandName;
        (function (CommandName) {
            CommandName["propertyChange"] = "PropertyChangeInteractionCommand";
        })(CommandName = serverForm.CommandName || (serverForm.CommandName = {}));
        var FormOpenMethod;
        (function (FormOpenMethod) {
            FormOpenMethod[FormOpenMethod["Display"] = 0] = "Display";
            FormOpenMethod[FormOpenMethod["Output"] = 1] = "Output";
            FormOpenMethod[FormOpenMethod["Action"] = 2] = "Action";
            FormOpenMethod[FormOpenMethod["Form"] = 3] = "Form";
        })(FormOpenMethod = serverForm.FormOpenMethod || (serverForm.FormOpenMethod = {}));
        (function (FormOpenMethod) {
            // Finds the enumeration based on the given string value. Case insensitive search is performed
            function find(strValue) {
                // Used to avoid strange typings caused by a merged enum+namespace
                var localFormOpenMethod = FormOpenMethod;
                // First try direct search
                var value = localFormOpenMethod[strValue];
                // If not found, try case insensitive search
                if (value === undefined) {
                    strValue = strValue.toLowerCase();
                    for (var candidate in $dyn.serverForm.FormOpenMethod) {
                        if (candidate.toLowerCase() === strValue && typeof candidate !== "function") {
                            value = localFormOpenMethod[candidate];
                            break;
                        }
                    }
                }
                return value;
            }
            FormOpenMethod.find = find;
        })(FormOpenMethod = serverForm.FormOpenMethod || (serverForm.FormOpenMethod = {}));
        var FormViewOption;
        (function (FormViewOption) {
            FormViewOption[FormViewOption["Auto"] = 0] = "Auto";
            FormViewOption[FormViewOption["Grid"] = 1] = "Grid";
            FormViewOption[FormViewOption["Details"] = 2] = "Details";
            FormViewOption[FormViewOption["Header"] = 3] = "Header";
            FormViewOption[FormViewOption["Hub"] = 5] = "Hub";
        })(FormViewOption = serverForm.FormViewOption || (serverForm.FormViewOption = {}));
        (function (FormViewOption) {
            // Finds the enumeration based on the given string value. Case insensitive search is performed
            function find(strValue) {
                // Used to avoid strange typings caused by a merged enum+namespace
                var localFormViewMode = FormViewOption;
                // First try direct search
                var value = localFormViewMode[strValue];
                // If not found, try case insensitive search
                if (value === undefined) {
                    for (var candidate in $dyn.serverForm.FormOpenMethod) {
                        if (candidate.localeCompare(strValue, undefined, { sensitivity: "case" }) === 0 && typeof candidate !== "function") {
                            value = localFormViewMode[candidate];
                            break;
                        }
                    }
                }
                return value;
            }
            FormViewOption.find = find;
        })(FormViewOption = serverForm.FormViewOption || (serverForm.FormViewOption = {}));
        /**
         * Enumeration that describes the type of value in a property descriptor
         */
        var ValueType;
        (function (ValueType) {
            /** The type of the value is a string */
            ValueType[ValueType["string"] = 1] = "string";
            /** The type of the value is an object */
            ValueType[ValueType["object"] = 2] = "object";
            /** The type of the value is a serialized string value of some other type */
            ValueType[ValueType["serialized"] = 3] = "serialized";
            /**
             * The type of the value is a collection of serialized string values of some other type.
             * The collection itself is not serialized.
             */
            ValueType[ValueType["collection"] = 4] = "collection";
        })(ValueType = serverForm.ValueType || (serverForm.ValueType = {}));
        var MessageType;
        (function (MessageType) {
            MessageType["message"] = "Message:#Microsoft.Dynamics.Client.InteractionService.Communication";
            MessageType["reliableMessage"] = "ReliableChannelMessage:#Microsoft.Dynamics.Client.InteractionService.Communication.Reliable";
        })(MessageType = serverForm.MessageType || (serverForm.MessageType = {}));
        var RequestHeaderKeys;
        (function (RequestHeaderKeys) {
            RequestHeaderKeys["sessionKey"] = "ms-dyn-sid";
            RequestHeaderKeys["companyKey"] = "ms-dyn-cmp";
            RequestHeaderKeys["partitionKey"] = "ms-dyn-prt";
            RequestHeaderKeys["languageKey"] = "ms-dyn-lng";
            RequestHeaderKeys["clientSessionKey"] = "ms-dyn-bsid";
            RequestHeaderKeys["activityKey"] = "ms-dyn-aid";
            RequestHeaderKeys["hostNameKey"] = "ms-dyn-fqhn";
            RequestHeaderKeys["namespaceKey"] = "ms-dyn-namespace";
            RequestHeaderKeys["tenantKey"] = "ms-dyn-tenant";
            RequestHeaderKeys["roleKey"] = "ms-dyn-role";
            RequestHeaderKeys["tokenKey"] = "ms-dyn-csrftoken";
            RequestHeaderKeys["sessionWaitTimeout"] = "ms-dyn-sid-timeout";
            RequestHeaderKeys["affinity"] = "ApplicationGatewayAffinity";
            RequestHeaderKeys["sfAffinity"] = "ms-dyn-affinity";
            RequestHeaderKeys["sessionLoggableKey"] = "ms-dyn-slk";
            RequestHeaderKeys["aosId"] = "ms-dyn-aosid";
        })(RequestHeaderKeys = serverForm.RequestHeaderKeys || (serverForm.RequestHeaderKeys = {}));
        serverForm.cachedPartFormInteractions = {};
        serverForm.partFormCacheUpdated = new $dyn.eventHost();
        // Assuming no command will have a larger throttle period than 9999ms
        serverForm.maximumThrottleTime = 9999;
        serverForm.sessionExpired = false;
        serverForm.enableSessionTimeout = true;
        serverForm.sessionTimeoutRemainWarningTime = 30; // 30 seconds
        serverForm.sessionTimeoutRemainWarningShown = false;
        /** Maximum time to wait before retrying a reliable channel request */
        serverForm.maxWaitTimeToRetry = 2 * 1000;
        /** Timeout for initiating a session request. This may take long on a cold start or for a heavy form */
        serverForm.sessionInitiationTimeout = 5 * 60 * 1000;
        /** Maximum time to wait on a single reliable channel request within a session before canceling it and retrying */
        serverForm.sessionRequestTimeout = 15 * 1000;
        /** Maximum time to retry requests that didn't complete */
        serverForm.maxRetryTimeWhenIncompleteRequest = 60 * 1000;
        /** Retry interval when requests are not completed */
        serverForm.retryTimeWhenIncompleteRequest = 15 * 1000;
        /** Maximum time to wait in milliseconds for a session lock when we retry the request */
        serverForm.sessionWaitTimeoutOnRetry = 10 * 1000;
        /** Interval of when pings get sent in milliseconds */
        serverForm.pingInterval = 2 * 60 * 1000; // 2 minutes
        /** Flight name for serverform ping */
        serverForm.pingFlightName = "CLIServerFormPing";
        serverForm.processingInteractions = $dyn.observable(false);
        /**
         * Indicating if the AOS server is in draining mode.
         * @description Currently all requests from the same client are processed by the same AOS server. So it's okay this flag is global on the browser across sessions.
         */
        serverForm.aosDraining = false;
        /**
         * Update the client session timeout warning based on sessionTimeout
         * @internal
         */
        function setSessionTimeoutRemainWarningTime() {
            // calculate the timewarning value
            if ($dyn.serverForm.sessionTimeout > $dyn.serverForm.TimeValues.ThirtyMinutes * 1000) {
                $dyn.serverForm.sessionTimeoutRemainWarningTime = $dyn.serverForm.TimeValues.FiveMinutes;
            }
            else if ($dyn.serverForm.sessionTimeout > $dyn.serverForm.TimeValues.TenMinutes * 1000) {
                $dyn.serverForm.sessionTimeoutRemainWarningTime = $dyn.serverForm.TimeValues.TwoMinutes;
            }
            else {
                $dyn.serverForm.sessionTimeoutRemainWarningTime = $dyn.serverForm.TimeValues.ThirtySeconds;
            }
        }
        serverForm.setSessionTimeoutRemainWarningTime = setSessionTimeoutRemainWarningTime;
        /**
         * Update the client session timeout based on server content.
         * @internal
         */
        function setWebClientStatefulSessionTimeoutInSeconds() {
            if ($dyn.user() && !isNaN(parseInt($dyn.user().WebClientStatefulSessionTimeoutInSeconds(), 10))) {
                // value desired is in milliseconds
                $dyn.serverForm.sessionTimeout = parseInt($dyn.user().WebClientStatefulSessionTimeoutInSeconds(), 10) * 1000;
                $dyn.serverForm.setSessionTimeoutRemainWarningTime();
                $dyn.serverForm.resetSessionTimeout();
            }
            else {
                // set the default timeout on start, it will get updated when server sends it down.
                // if no value default it to which is 1 hour in milliseconds.
                $dyn.serverForm.sessionTimeout = 60 * 60 * 1000;
                $dyn.serverForm.setSessionTimeoutRemainWarningTime();
            }
        }
        serverForm.setWebClientStatefulSessionTimeoutInSeconds = setWebClientStatefulSessionTimeoutInSeconds;
        /**
         * Update the client max timeout for reliable communicaton events.
         * @internal
         */
        function setMaxWaitTimeToFailInMinutes() {
            if ($dyn.user() && !isNaN(parseInt($dyn.user().MaxWaitTimeToFailInMinutes(), 10))) {
                // value desired is in milliseconds
                $dyn.serverForm.maxWaitTimeToFail = parseInt($dyn.user().MaxWaitTimeToFailInMinutes(), 10) * 60 * 1000;
            }
            else {
                $dyn.serverForm.maxWaitTimeToFail = 10 * 60 * 1000;
            }
        }
        serverForm.setMaxWaitTimeToFailInMinutes = setMaxWaitTimeToFailInMinutes;
        // call once to setup defaults until server comes back with interaction data
        $dyn.serverForm.setWebClientStatefulSessionTimeoutInSeconds();
        $dyn.serverForm.setMaxWaitTimeToFailInMinutes();
        function resetSessionTimeout(sendKeepAliveInteraction) {
            var shouldSendKeepSessionAlive = sendKeepAliveInteraction === undefined ? true : sendKeepAliveInteraction;
            if ($dyn.serverForm.sessionTimeoutId && !$dyn.serverForm.sessionTimeoutRemainWarningShown && !$dyn.serverForm.sessionExpired) {
                clearTimeout($dyn.serverForm.sessionTimeoutId);
                clearTimeout($dyn.serverForm.sessionTimeoutIdWarning);
            }
            if ($dyn.serverForm.enableSessionTimeout && !$dyn.serverForm.sessionTimeoutRemainWarningShown && !$dyn.serverForm.sessionExpired) {
                $dyn.serverForm.sessionTimeoutId = window.setTimeout(function () {
                    var user = $dyn.value($dyn.user);
                    if (user && $dyn.value(user.SessionExpireAutoLogoff)) {
                        // logout
                        $dyn.shell.logOut();
                    }
                    else {
                        $dyn.serverForm.endSession();
                        $dyn.serverForm.sessionExpired = true;
                        $dyn.serverForm.reset();
                        if ($dyn.serverForm._pingTimeoutId) {
                            clearInterval($dyn.serverForm._pingTimeoutId);
                            $dyn.serverForm._pingTimeoutId = 0;
                            $dyn.log.server && $dyn.log.server("ServerForm: Ping interval with id %s has been cleared", $dyn.serverForm._pingTimeoutId);
                        }
                        if ($dyn.boot.monitoringInterval) {
                            clearInterval($dyn.boot.monitoringInterval);
                            $dyn.boot.monitoringInterval = undefined;
                        }
                        $dyn.showTimeoutDialog({ type: "Reconnect" });
                    }
                }, $dyn.serverForm.sessionTimeout);
                $dyn.serverForm.sessionTimeoutIdWarning = window.setTimeout(function () {
                    $dyn.serverForm.sessionTimeoutRemainWarningShown = true;
                    $dyn.showTimeoutDialog({ type: "Logout", timerCountDown: $dyn.serverForm.sessionTimeoutRemainWarningTime });
                }, 
                // actually pop the timer 5 seconds early for user delay
                $dyn.serverForm.sessionTimeout - ($dyn.serverForm.sessionTimeoutRemainWarningTime + $dyn.serverForm.TimeValues.FiveSeconds) * 1000);
                // if the last time I have sent an interaction to the server is longer than half the sessionTimeout period
                // for a channel then send a dummy interaction on that channel to keep the server session alive
                if ($dyn.serverForm.interactionManager && $dyn.serverForm.interactionManager.channelPool && shouldSendKeepSessionAlive) {
                    var channelPool = $dyn.serverForm.interactionManager.channelPool();
                    if (channelPool) {
                        // tslint:disable-next-line:prefer-for-of
                        for (var i = 0; i < channelPool.length; i++) {
                            var interactionChannel = channelPool[i];
                            var channel = interactionChannel && interactionChannel.channel ? interactionChannel.channel : undefined;
                            if (channel && channel.serverSessionId && channel._lastStartTime) {
                                if (window.performance.now() - channel._lastStartTime > $dyn.serverForm.sessionTimeout / 2) {
                                    $dyn.serverForm.keepSessionAlive(interactionChannel);
                                }
                            }
                        }
                    }
                }
            }
        }
        serverForm.resetSessionTimeout = resetSessionTimeout;
        window.setTimeout(function () {
            if ($dyn.serverForm && $dyn.serverForm.enableSessionTimeout) {
                $dyn.serverForm.resetSessionTimeout();
                var eventHandler = function () { return $dyn.serverForm.resetSessionTimeout(); };
                window.addEventListener("mousedown", eventHandler, true);
                window.addEventListener("keydown", eventHandler, true);
            }
        }, 1000);
        function restoreCurrentSession() {
            var commandInteraction = {
                $type: $dyn.serverForm.InteractionType.restoreServerSession,
                ServerSessionId: $dyn.serverForm.defaultChannel().channel.serverSessionId,
                ShouldBlockOnExecution: true,
                TargetId: "0_0",
            };
            $dyn.serverForm.defaultChannel._instance = null;
            $dyn.serverForm.interactionManager.reset();
            var channelOptions = {
                channel: $dyn.serverForm.defaultChannel(),
                channelType: $dyn.serverForm.InteractionChannelType.byChannel,
            };
            $dyn.serverForm.interactionManager.queueInteraction(commandInteraction, channelOptions, true);
        }
        serverForm.restoreCurrentSession = restoreCurrentSession;
        function endSession(sessionToKeep) {
            var sessionIds = [];
            if ($dyn.serverForm.interactionManager && $dyn.serverForm.interactionManager.channelPool) {
                var channelPool = $dyn.serverForm.interactionManager.channelPool();
                if (channelPool) {
                    // tslint:disable-next-line:prefer-for-of
                    for (var i = 0; i < channelPool.length; i++) {
                        var interactionChannel = channelPool[i];
                        if (interactionChannel && interactionChannel.channel && interactionChannel.channel.serverSessionId &&
                            (!sessionToKeep || sessionToKeep !== interactionChannel.channel.serverSessionId)) {
                            sessionIds.push(interactionChannel.channel.serverSessionId);
                            // reset serverSesionId to prevent duplicate EndSessions request gets sent if endSession() is called again
                            interactionChannel.channel.serverSessionId = undefined;
                        }
                    }
                }
            }
            if (sessionIds.length > 0) {
                var url_1 = "Services/SessionManager.svc/EndSessions";
                var data = JSON.stringify(sessionIds);
                if (navigator.sendBeacon) {
                    // Using the sendBeacon() method, the data will be transmitted asynchronously to the web server
                    // without delaying the unload or affecting the performance of the next navigation.
                    // sendBeacon method is supported in Chrome and Firefox.
                    navigator.sendBeacon(url_1, data);
                }
                else {
                    // IE and Safari do not support sendBeacon.
                    $.ajax({
                        async: false,
                        contentType: "application/json; charset=utf-8",
                        data: data,
                        dataType: "json",
                        headers: {
                            "ms-dyn-aid": $dyn.util.newGuid(),
                            "ms-dyn-bsid": $dyn.browserActivity.BrowserSessionActivity.Id,
                            "ms-dyn-csrftoken": $dyn.serverForm.getCsrfTokenValue(),
                        },
                        timeout: 60 * 1000 /* 60 sec */,
                        type: "POST",
                        url: url_1,
                    });
                }
            }
        }
        serverForm.endSession = endSession;
        function _debugDescriptor(targetElement, descriptor) {
            if ($dyn.debug.general) {
                var descriptors = targetElement.dynPrevDescriptors;
                if (!descriptors) {
                    descriptors = [];
                }
                descriptors.push(descriptor);
                targetElement.dynPrevDescriptors = descriptors;
            }
        }
        serverForm._debugDescriptor = _debugDescriptor;
        function getForm(options) {
            if ($dyn.serverForm.aosDraining) {
                var isRootNavigation = options.NavigationPath && options.NavigationPath.length > 0;
                var isUsingTaskRecorder = $dyn.value($dyn.ax.taskRecording.isRecording) || $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
                var isTracing = $dyn.value($dyn.ax._tracing.started);
                var isAsidePaneOpen = $dyn.value($dyn.shell.isAsidePaneOpen);
                if (isRootNavigation && !isUsingTaskRecorder && !isTracing && !isAsidePaneOpen) {
                    // Destroy existing sessions before starting root navigation
                    $dyn.serverForm.endSession();
                    // Reset server form. Clear old channels, and get new channels. This will clear serverSessionId for each channel.
                    // AOS kernel will then create new session when processing a request from a new channel with no sessionID associated.
                    $dyn.serverForm.reset();
                    // Dispose help pane
                    $dyn.ax.helpPane.pane = undefined;
                    // Dispose task recorder pane
                    $dyn.ax.taskRecording.pane = undefined;
                    // Dispose tracing pane
                    $dyn.ax._tracing.pane = undefined;
                    // Clear affinity cookie so the request will be load balanced to a different AOS instance.
                    $dyn.serverForm.clearAffinity();
                }
            }
            options.targetElement.dynPerformance.requestStart = window.performance.now();
            var type = options.menuItem ? "MenuItem" : "Form";
            var name = options.menuItem ? options.menuItem : options.name;
            var telemetryOptions = { targetType: type };
            $dyn.telemetry.addPerformanceEvent(name, "0", $dyn.telemetry.PerformanceEvents.openStart, telemetryOptions);
            $dyn.serverForm.interactionHandler.getForm(options);
        }
        serverForm.getForm = getForm;
        function registerForm(options) {
            var targetElement = options.targetElement;
            var formId = targetElement.getAttribute("data-dyn-formid");
            $dyn.serverForm.interactionHandler.forms[formId] = targetElement;
        }
        serverForm.registerForm = registerForm;
        function initialForm() {
            var query = $dyn.util.location.query;
            var recordContext = query.q;
            var pageType = query.pagetype;
            // Don't make an initial form if we're a popout.
            if (query.popout) {
                return { elementCreated: undefined };
            }
            if (query.f) {
                return {
                    elementCreated: $dyn.serverForm.getForm,
                    name: query.f.toLowerCase(),
                    pagetype: pageType,
                    recordcontext: recordContext,
                    role: "Form",
                };
            }
            if (query.mi) {
                return {
                    elementCreated: $dyn.serverForm.getForm,
                    menuItem: query.mi.toLowerCase(),
                    pagetype: pageType,
                    recordcontext: recordContext,
                    role: "Form",
                };
            }
            return $dyn.shell.defaultForm;
        }
        serverForm.initialForm = initialForm;
        serverForm.infologModel = new $dyn.serverForm.Model();
        $dyn.serverForm.infologModel.id = "ClientMessageLog";
        $dyn.serverForm.ModelManager.trackModel($dyn.serverForm.infologModel);
        serverForm.infologCollection = $dyn.serverForm.infologModel.getRelatedCollection("ClientMessageLog");
        $dyn.serverForm.infologCollection.id = "ClientMessageLog";
        $dyn.serverForm.ModelManager.trackModelCollection($dyn.serverForm.infologCollection);
        $dyn.observe($dyn.serverForm.infologCollection.items, function (messages) {
            var messageArray = new Array();
            if (messages) {
                for (var i = 0, len = messages.length; i < len; i++) {
                    var message = messages[i];
                    var kind = parseInt(message.getValue("kind"), 10);
                    // FormContext is the formName, messageContext is the name of the control that generated the message
                    // todo create right type
                    var msg = new $dyn.messaging.Message();
                    msg.text = message.getValue("text");
                    msg.stackTrace = message.getValue("stackTrace");
                    msg.messageId = message.getValue("messageId");
                    msg.type = kind;
                    if (msg.type === $dyn.messaging.MessageType.systemMaintenance) {
                        var localTime = moment.utc(msg.text).toDate();
                        localTime = moment(localTime).format("YYYY-MM-DD HH:mm");
                        msg.text = $dyn.format($dyn.label("ServerForm_SystemMaintenance"), localTime);
                    }
                    msg.timeStampMomentUtc = moment.utc(message.getValue("timeStamp"));
                    msg.Id = message.id;
                    msg.formName = message.getValue("formContext");
                    var formId = message.getValue("formUniqueId");
                    msg.formUniqueId = formId === "0_0" ? "" : formId;
                    var parentFormId = message.getValue("parentFormUniqueId");
                    msg.parentFormId = parentFormId === "0_0" ? "" : parentFormId;
                    msg.targetName = message.getValue("messageContext");
                    msg.destination = message.getValue("destination");
                    msg.activityId = message.getValue("activityId");
                    msg.ActionMessageText = message.getValue("actionText");
                    msg.isStaticAction = $dyn.util.stringToBoolean(message.getValue("isStaticAction"));
                    msg.elapsedTimeSinceArrival = $dyn.observable("");
                    // tslint:disable-next-line:triple-equals
                    if (message.getValue("deleteMessage") == "0") {
                        msg.deleteMessage = false;
                    }
                    else {
                        msg.deleteMessage = true;
                    }
                    messageArray.push(msg);
                }
                if (messageArray.length > 0) {
                    $dyn.messageManager.addMessages(messageArray);
                    $dyn.serverForm.infologCollection.items([]);
                }
            }
        });
        function keepSessionAlive(interactionChannel) {
            var commandInteraction = {
                $type: $dyn.serverForm.InteractionType.command,
                CommandName: "KeepAlive",
                RootId: 0,
                TargetId: "0_0",
            };
            $dyn.serverForm.interactionManager.queueInteraction(commandInteraction, { channelType: $dyn.serverForm.InteractionChannelType.byChannel, channel: interactionChannel }, true);
        }
        serverForm.keepSessionAlive = keepSessionAlive;
        // TODO: optimize use of controlParams
        function updateTrigger(controlParams, observableProperty, options) {
            if (!observableProperty) {
                return;
            }
            var changeValue = true;
            var autoPostback = true;
            var propertyChangeCommandName = "Value";
            if (options) {
                changeValue = options.ChangeValue !== undefined ? options.ChangeValue : true;
                autoPostback = options.AutoPostback !== undefined ? options.AutoPostback : true;
                propertyChangeCommandName = options.command;
            }
            if (observableProperty && observableProperty.__triggerId !== undefined) {
                observableProperty.valueChanged.unsubscribe(observableProperty.__triggerId);
            }
            var oldValue = $dyn.peek(observableProperty);
            observableProperty.__triggerId = observableProperty.valueChanged.subscribe(function (observable, forceChange) {
                if (!observableProperty.__bindingUpdating) {
                    var value_1 = $dyn.peek(observableProperty);
                    if (value_1 !== oldValue || forceChange) {
                        var propertyChange_1 = {
                            $type: $dyn.serverForm.InteractionType.propertyChange,
                            PropertyName: propertyChangeCommandName,
                            RootId: $dyn.serverForm.interactionHandler.getRootIdByElement(controlParams._element),
                            TargetId: controlParams._serverId,
                        };
                        propertyChange_1.beforeExecute = function () {
                            propertyChange_1.NewValue = $.isPlainObject(value_1) || $.isArray(value_1) ? JSON.stringify(value_1) : value_1;
                        };
                        propertyChange_1.RootId = $dyn.serverForm.interactionHandler.getRootIdByElement(controlParams._element);
                        if (!autoPostback) {
                            propertyChange_1.NoAsyncIncrement = true;
                        }
                        var channelOptions = {
                            channelType: $dyn.serverForm.InteractionChannelType.byRootId,
                            rootId: propertyChange_1.RootId,
                        };
                        $dyn.serverForm.interactionManager.queueInteraction(propertyChange_1, channelOptions, autoPostback);
                    }
                }
                oldValue = $dyn.value;
            });
        }
        serverForm.updateTrigger = updateTrigger;
        function getControlParams(controlName, rootControlParams) {
            if (!controlName || !rootControlParams) {
                return null;
            }
            var returnParams;
            var allControls = rootControlParams._allControls;
            if (allControls) {
                returnParams = allControls[controlName.toLowerCase()];
                if (!returnParams && controlName === rootControlParams._name) {
                    returnParams = rootControlParams;
                }
            }
            return returnParams;
        }
        serverForm.getControlParams = getControlParams;
        function getElementControlParams(element) {
            var controlParams;
            var rootElement;
            try {
                rootElement = $dyn.rootElement(element);
            }
            catch (e) {
                // Ignore errors
            }
            if (rootElement && rootElement.dynOptions) {
                var parents = $(element).parents().addBack();
                // Walk up the parents until we find a serverform control
                for (var i = parents.length - 1; i >= 0; i--) {
                    var name_1 = void 0;
                    // When traversing up if we have a column then we have to select that column header by its column name.
                    // column header do not have attribute data-dyn-controlname
                    if (parents[i].hasAttribute("data-dyn-columnname")) {
                        name_1 = parents[i].getAttribute("data-dyn-columnname");
                    }
                    else {
                        name_1 = parents[i].getAttribute("data-dyn-controlname");
                    }
                    controlParams = $dyn.serverForm.getControlParams(name_1, rootElement.dynOptions);
                    if (controlParams) {
                        break;
                    }
                }
            }
            return controlParams;
        }
        serverForm.getElementControlParams = getElementControlParams;
        // Retrieve the control element with the given controlname, starting at and including the rootElement
        function getElement(controlName, rootControlParams) {
            var controlParams = $dyn.serverForm.getControlParams(controlName, rootControlParams);
            if (controlParams) {
                return controlParams._element;
            }
            return null;
        }
        serverForm.getElement = getElement;
        function getModel(id) {
            var context;
            if ($dyn.serverForm.ModelManager.models[id] && $dyn.serverForm.ModelManager.models[id][id]) {
                context = $dyn.serverForm.ModelManager.models[id][id];
            }
            else {
                context = new $dyn.serverForm.Model();
                context.id = id;
                $dyn.serverForm.ModelManager.trackModel(context, id);
            }
            return context;
        }
        serverForm.getModel = getModel;
        /**
         * Raises the form level serializeTransitState which notifies that any client-only state is to be saved.
         * In order to use this event properly, controls must do 4 things:
         * 1. Subscribe to their Root form's event when they have client-only state that they want saved, and unsubscribe when the client-only state is losable.
         * 2. Define the method onSerializeTransitState which is what is to be subscribed to the form event
         * 3. Define a property on the server called ClientState which they will set in their handler method.
         *   - the ClientState property will hold a stringified JSON object which they fill with properties they want saved.
         *   - example ClientState property would look like: ClientState: '{"property1":"abcd","property2":123}'
         * 4. Add additional logic to read from the ClientState property and apply the properties as they wish.
         * @param formId The ID of the form to serialize
         */
        function saveTransitState(formId) {
            // Get the form from the formId
            var form = $dyn.context($dyn.serverForm.interactionHandler.getFormElement(formId));
            // Raise the serializeState event on the form.
            form.serializeTransitState.raise();
        }
        serverForm.saveTransitState = saveTransitState;
        function init() {
            // Override the navigation pane server access function to point to the interaction service
            $dyn.DynReact.ModuleStore._requestMenuStructure = function (targetId, callback, options) {
                if (!$dyn.serverForm) {
                    /// #DEBUG
                    $dyn.logError("Access to $dyn.serverForm is required for retrieving the menu structure.");
                    /// #ENDDEBUG
                    return;
                }
                else {
                    var getMenuStructureInteraction = {
                        $type: $dyn.serverForm.InteractionType.getMenuStructureInteraction,
                        CommandName: "GetMenuStructureInteraction",
                        ShouldBlockOnExecution: false,
                        TargetId: targetId,
                    };
                    if (options && options.menuItem) {
                        getMenuStructureInteraction.NamedParameters = { Args1: options.menuItem };
                    }
                    if (options && options.state) {
                        getMenuStructureInteraction.NamedParameters = { Args1: options.state };
                    }
                    $dyn.serverForm.interactionManager.queueCallbackCommandInteraction(getMenuStructureInteraction, callback, {}, true);
                }
            };
            $dyn.serverForm.defaultChannel = function () {
                if (!$dyn.serverForm.defaultChannel._instance) {
                    var channel = new $dyn.serverForm.ReliableChannel();
                    $dyn.serverForm.defaultChannel._instance = new $dyn.serverForm.InteractionChannel(channel);
                    channel.enableSessionTimeout = $dyn.serverForm.enableSessionTimeout;
                }
                return $dyn.serverForm.defaultChannel._instance;
            };
            var query = $dyn.util.location.query;
            // query.popout will be the integer which represents our window Id.
            if (query.popout) {
                $dyn.serverForm.initPopout(query);
            }
            else {
                $dyn.serverForm.initHost();
            }
            window.addEventListener("unload", $dyn.serverForm._windowManager.closeWindow);
            $dyn.shell.hasRestrictedInternet.valueChanged.subscribe(function (connected) {
                var user = $dyn.value($dyn.user);
                if (!user || $dyn.value(user.ClientConnectivityEnabled)) {
                    $dyn.serverForm.sendClientRestrictedInternetInteraction({ internetRestricted: $dyn.value(connected) });
                }
            });
        }
        serverForm.init = init;
        function sendClientRestrictedInternetInteraction(options) {
            if (!$dyn.serverForm) {
                /// #DEBUG
                $dyn.logError("Access to $dyn.serverForm is required for set the system information.");
                /// #ENDDEBUG
                return;
            }
            else {
                var clientRestrictedInternetInteraction = {
                    $type: $dyn.serverForm.InteractionType.clientRestrictedInternetInteraction,
                    CommandName: "ClientInternetRestrictedInteraction",
                    InternetRestricted: options.internetRestricted,
                    PriorityPosition: true,
                    ShouldBlockOnExecution: false,
                    TargetId: "setClientRestrictedInternet",
                };
                $dyn.serverForm.interactionManager.queueCallbackCommandInteraction(clientRestrictedInternetInteraction, function () { }, {}, true);
            }
        }
        serverForm.sendClientRestrictedInternetInteraction = sendClientRestrictedInternetInteraction;
        function createClientMessageLogInteraction(messages) {
            var newClientMessageLogInteraction = {
                $type: $dyn.serverForm.InteractionType.updateModelCollection,
                Descriptor: {
                    Id: "ClientMessageLog",
                    Items: messages,
                    Name: "ClientMessageLog",
                },
                RootId: "ClientMessageLog",
            };
            return newClientMessageLogInteraction;
        }
        serverForm.createClientMessageLogInteraction = createClientMessageLogInteraction;
        function initPopout(query) {
            // If we are a popout.
            // Init a proxy manager (to point to the host)
            $dyn.serverForm.interactionManager = new $dyn.serverForm.InteractionManagerProxy();
            // Initialize an array to map window function ids to callbacks
            $dyn.serverForm.idToWindowFunction = {};
            // Initialize window function id
            $dyn.serverForm.windowFunctionId = 0;
            // Init a real interactionHandler
            $dyn.serverForm.interactionHandler = new $dyn.serverForm.InteractionHandler();
            $dyn.serverForm._windowManager = new $dyn.serverForm._WindowManagerPopout();
            // Hook up our interactionHandler to listen for messages posted from the Host
            window.addEventListener("message", $dyn.serverForm.interactionHandler.handleMessages);
            window.addEventListener("message", $dyn.serverForm._windowManager.handleMessages);
            $dyn.serverForm.initPopoutMessageCenter();
            // Set my window Id
            $dyn.serverForm._windowId = parseInt(query.popout, 10);
            var rootId = query.rootId;
            if (window.opener) {
                $dyn.parentWindow = window.opener.$dyn.parentWindow;
            }
            else {
                $dyn.logError("Cannot set parent window for popout window; please contact your administrator.");
            }
            if (query.newPopout) {
                // Remove newPopout so that we do not attempt to re-initialize this popout window on window reload (F5).
                $dyn.ui.updateQueryStringParameter("newPopout", null);
                $dyn.serverForm.compilation.StaticLoader.staticLoaderOn = false; // turn off static loader completely for popout forms
                $dyn.ui.updateQueryStringParameter("popout", query.popout);
                $dyn.serverForm._windowManager.windowLoadCallback({ window: window, windowId: $dyn.serverForm._windowId, rootId: rootId });
            }
            else {
                // Show a message to the user and clean up the popout (if needed) so we don't error out
                $dyn.errorMessageBox({
                    callback: function () {
                        window.close();
                    },
                    Label: "WindowManager_CannotReloadPopout",
                    Text: $dyn.label("WindowManager_CannotReloadPopout"),
                });
            }
        }
        serverForm.initPopout = initPopout;
        function initPopoutMessageCenter() {
            // Redefine this function on a popout so that it routes the message id's to the main window to be replayed.
            if ($dyn.messageManager &&
                $dyn.messageManager.messageHandlers &&
                $dyn.messageManager.messageHandlers.clientMessageHandler &&
                $dyn.messageManager.messageHandlers.clientMessageHandler.messageCenter) {
                $dyn.messageManager.messageHandlers.clientMessageHandler.messageCenter = $dyn.serverForm.ProxyMessageCenterManager;
            }
        }
        serverForm.initPopoutMessageCenter = initPopoutMessageCenter;
        function initHost() {
            // If we are the Host.
            // Init a real manager
            $dyn.serverForm.interactionManager = new $dyn.serverForm.InteractionManager();
            $dyn.serverForm.interactionManager.init();
            // Hook up the manager to listen for messages posted from the children windows
            window.addEventListener("message", $dyn.serverForm.interactionManager.handleMessages);
            // Init a real local interactionHandler and add it to the pool of handlers
            $dyn.serverForm.interactionHandler = new $dyn.serverForm.InteractionHandler();
            $dyn.serverForm._windowManager = new $dyn.serverForm._WindowManager();
            // Setup listener for MessageCenter messages that need to be replayed on the main window
            var handlePopoutMessageCenterMessages = function (event) {
                if (event.origin !== $dyn.util.getOrigin($dyn.util.location.location)) {
                    // Do not allow communication if it is cross origin.
                    return;
                }
                var options = event.data;
                // Sanity check. Ensure these are coming for the MessageCenter
                if (typeof options === "object" && options.source === "MessageCenter") {
                    if (options.commandName === "ReplayMessageOnMainWindow") {
                        var messagesToReplay = [];
                        var cachedMessages = $dyn.serverForm.messageInteractionBuffer.getMessagesInOrder();
                        // tslint:disable-next-line:prefer-for-of
                        for (var i = 0; i < cachedMessages.length; i++) {
                            // tslint:disable-next-line:prefer-for-of
                            for (var j = 0; j < options.messageIds.length; j++) {
                                if (options.messageIds[j] === cachedMessages[i].Id) {
                                    messagesToReplay.push(cachedMessages[i]);
                                }
                            }
                        }
                        var newClientMessageLogInteraction = $dyn.serverForm.createClientMessageLogInteraction(messagesToReplay);
                        $dyn.serverForm.interactionHandler.processInteractions([newClientMessageLogInteraction]);
                    }
                    else if (options.commandName === "RemoveMessage") {
                        $dyn.messageManager.messageHandlers.clientMessageHandler.messageCenter.RemoveMessage(options.messageId);
                    }
                    else if (options.commandName === "ClearMessages") {
                        $dyn.messageManager.messageHandlers.clientMessageHandler.messageCenter.ClearMessages();
                    }
                }
            };
            window.addEventListener("message", handlePopoutMessageCenterMessages);
            window.addEventListener("message", $dyn.serverForm._windowManager.handleMessages);
            // Set my window Id and register my interactionHandler.
            $dyn.serverForm._windowId = $dyn.serverForm._windowManager.getNextWindowId();
            $dyn.serverForm.interactionManager.addWindowHandler($dyn.serverForm._windowId, $dyn.serverForm.interactionHandler);
            // Set the parent window to be itself.
            $dyn.parentWindow = window;
        }
        serverForm.initHost = initHost;
        function closeAllPopouts(successCallback, errorCallback) {
            return $dyn.serverForm._windowManager.requestCloseAllPopouts(successCallback, errorCallback);
        }
        serverForm.closeAllPopouts = closeAllPopouts;
        function forceCloseAllPopouts() {
            if ($dyn.serverForm._windowManager && $dyn.serverForm._windowManager.forceCloseAllPopouts) {
                $dyn.serverForm._windowManager.forceCloseAllPopouts();
            }
        }
        serverForm.forceCloseAllPopouts = forceCloseAllPopouts;
        function pingReset() {
            if ($dyn.serverForm._pingTimeoutId) {
                clearInterval($dyn.serverForm._pingTimeoutId);
                $dyn.log.server && $dyn.log.server("ServerForm: Ping interval with id %s has been cleared", $dyn.serverForm._pingTimeoutId);
            }
            if (!$dyn.util.isFlightEnabled($dyn.serverForm.pingFlightName)) {
                $dyn.log.server && $dyn.log.server("ServerForm: Ping is disabled via flighting and will not be reset.");
                return;
            }
            $dyn.serverForm._pingTimeoutId = window.setInterval(function () {
                var ping = window.performance.now();
                var date = new Date();
                var dateTime = date.toString();
                var ajaxOptions = {};
                // Restricting to POST
                ajaxOptions.type = "POST";
                ajaxOptions.url = $dyn.util.resolveVirtualPath("/ping");
                ajaxOptions.cache = false;
                ajaxOptions.beforeSend = function (request) {
                    $dyn.serverForm.setCsrfToken(request);
                    var activityKey = $dyn.util.newGuid();
                    request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.clientSessionKey, $dyn.browserActivity.BrowserSessionActivity.Id);
                    request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.activityKey, activityKey);
                    $dyn.browserActivity && $dyn.browserActivity.newInteraction(activityKey);
                    $dyn.log.server && $dyn.log.server("ServerForm: Ping request sent at %s", dateTime);
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addAction("Ping");
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._startAjax(activityKey);
                };
                ajaxOptions.success = function (data, textStatus, request) {
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                    ping = window.performance.now() - ping;
                    if ($dyn.telemetry.pingCount < 5) {
                        $dyn.telemetry.addPingEvent(ping);
                        $dyn.telemetry.pingCount++;
                    }
                    $dyn.log.server && $dyn.log.server("ServerForm: Ping response received in %s ms", ping);
                };
                ajaxOptions.error = function (request, textStatus, error) {
                    $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._stopAjax();
                    $dyn.logError(error);
                };
                ajaxOptions.timeout = 60 * 1000; /* 60 sec */
                $.ajax(ajaxOptions);
            }, $dyn.serverForm.pingInterval);
            $dyn.log.server && $dyn.log.server("ServerForm: New ping interval with id %s has been set", $dyn.serverForm._pingTimeoutId);
        }
        serverForm.pingReset = pingReset;
        function getCsrfTokenValue() {
            var tokenSearchKey = $dyn.serverForm.RequestHeaderKeys.tokenKey + "=";
            var cookies = document.cookie.split(";");
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < cookies.length; i++) {
                var kvp = cookies[i].trim();
                if (kvp.indexOf(tokenSearchKey) === 0) {
                    return kvp.substr(tokenSearchKey.length);
                }
            }
            return undefined;
        }
        serverForm.getCsrfTokenValue = getCsrfTokenValue;
        function setCsrfToken(request) {
            var tokenValue = $dyn.serverForm.getCsrfTokenValue();
            if (tokenValue) {
                request.setRequestHeader($dyn.serverForm.RequestHeaderKeys.tokenKey, tokenValue);
            }
        }
        serverForm.setCsrfToken = setCsrfToken;
        function clearAffinity() {
            var clearAffinityCookie = function (cookieName) {
                var searchKey = cookieName + "=";
                if (document.cookie.indexOf(searchKey) > -1) {
                    var date_1 = new Date();
                    date_1.setTime(date_1.getTime() - 24 * 60 * 60 * 1000);
                    // Delete affinity cookie by setting its expiration date to the past and defining a blank value
                    // When deleting a cookie, we must use the exact same parameters used when setting the cookie. Otherwise the cookie will not be deleted.
                    document.cookie = cookieName + "=; expires=" + date_1.toUTCString() + "; path=/; domain=" + $dyn.util.location.authority;
                }
            };
            clearAffinityCookie($dyn.serverForm.RequestHeaderKeys.affinity);
            clearAffinityCookie($dyn.serverForm.RequestHeaderKeys.sfAffinity);
        }
        serverForm.clearAffinity = clearAffinity;
        /** Utility to get whether a value is an interaction command. */
        function isInteractionCommand(command) {
            return typeof command === "function" && command._interactionCommand;
        }
        serverForm.isInteractionCommand = isInteractionCommand;
        serverForm.CommandsAffectingSave = ["SetValue", "SetSelectedItem", "ResolveChanges", "NavigationAction", "set_IsValid"];
        serverForm.PropertiesAffectingSave = ["IsValid"];
        function couldInteractionAffectSave(interaction) {
            var retVal = false;
            if (interaction) {
                if (interaction.$type === "CommandInteraction") {
                    var commandInteraction = interaction;
                    if (serverForm.CommandsAffectingSave.includes(commandInteraction.CommandName)) {
                        retVal = true;
                    }
                }
                else if (interaction.$type === "PropertyChangeInteraction") {
                    var propertyChangeInteraction = interaction;
                    if (serverForm.PropertiesAffectingSave.includes(propertyChangeInteraction.PropertyName)) {
                        retVal = true;
                    }
                }
            }
            return retVal;
        }
        serverForm.couldInteractionAffectSave = couldInteractionAffectSave;
        function reset(formName) {
            // force close any open popups
            $dyn.serverForm.forceCloseAllPopouts();
            // close shell previews and flyouts
            $dyn.shell.resetShellOnNavigation();
            var primaryConductor = document.getElementById("PrimaryConductor");
            if (primaryConductor) {
                primaryConductor.textContent = "";
            }
            $($dyn.value($dyn.shell.dialogStack)).each(function (index, element) {
                $(element).remove();
            });
            $($dyn.value($dyn.shell.stack)).each(function (index, formElement) {
                var thisForm = $dyn.context(formElement);
                if (thisForm && thisForm.dialogStack()) {
                    $($dyn.value(thisForm.dialogStack)).each(function (i, dialogElement) {
                        $(dialogElement).remove();
                    });
                }
            });
            $dyn.shell.stack.clear();
            $dyn.shell.dialogStack.clear();
            $dyn.shell.activeMessageBox = null;
            // To unbind flyouts
            $(document.body).off();
            $(document).off();
            // clear all messages
            $dyn.messageManager.clear();
            $dyn.shell.browserInit();
            $dyn.telemetry.addSessionBeginEvent();
            // clear old channels, and get new channels
            $dyn.serverForm.defaultChannel._instance = null;
            if ($dyn.serverForm.interactionManager) {
                $dyn.serverForm.interactionManager.reset();
            }
            if (formName) {
                delete $dyn.serverForm.compilation.formsCache[formName.toLowerCase()];
            }
            window.focus();
        }
        serverForm.reset = reset;
        function trackRenderTime(formName, renderTime) {
            if ($dyn.debug.trackFormPerformance && window.localStorage) {
                var item = window.localStorage.getItem("$dyn.serverForm.performance");
                if (item) {
                    $dyn.serverForm.performance = JSON.parse(item);
                }
                if (!$dyn.serverForm.performance) {
                    $dyn.serverForm.performance = {};
                }
                if (!$dyn.serverForm.performance[formName]) {
                    $dyn.serverForm.performance[formName] = [];
                }
                $dyn.serverForm.performance[formName].unshift(Globalize.format(new Date(), "MM/dd hh:mm") + " - " + renderTime);
                try {
                    window.localStorage.setItem("$dyn.serverForm.performance", JSON.stringify($dyn.serverForm.performance));
                }
                catch (e) {
                    $dyn.util.localStorageErorrHandler(e.name);
                }
            }
        }
        serverForm.trackRenderTime = trackRenderTime;
        function resetPerfTracking(formName, renderTime) {
            if ($dyn.debug.trackFormPerformance && window.localStorage) {
                $dyn.serverForm.performance = {};
                try {
                    window.localStorage.setItem("$dyn.serverForm.performance", JSON.stringify($dyn.serverForm.performance));
                }
                catch (e) {
                    $dyn.util.localStorageErorrHandler(e.name);
                }
            }
        }
        serverForm.resetPerfTracking = resetPerfTracking;
        $dyn.evaLoaded = false;
        $dyn.evaLoading = false;
        $dyn.ui.PerformanceTimer && $dyn.ui.PerformanceTimer._addNavBarButton();
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ServerForm.js.map
